import { render, staticRenderFns } from "./FailurePayment.vue?vue&type=template&id=dcf01838&"
import script from "./FailurePayment.vue?vue&type=script&lang=js&"
export * from "./FailurePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports